
export default class TestPortalData {
	constructor( 
        public IsEnabled: boolean,
        public Url: string,
        public Ciid: string
    ) { }
}